import { Dispatch } from 'redux';
import { loginActions } from "./slice";
import { makeApiRequest, RequestStatus, unsetCsrfToken } from '../../api_request/api_request'

export async function sendLogin(username:string, password: string, dispatch: Dispatch, lifeCycleCallback: (rs: RequestStatus) => any)
{
    const params =
    {
        username: username,
        password: password,
    };
    
    const response = await makeApiRequest({
        endpoint: 'login/',
        method: 'POST',
        postData: params,
        dispatch,
        lifeCycleCallback,
    });
    
    if (response.success)
    {
        const respData = JSON.parse(response?.responseText || '{}');
        dispatch(loginActions.setCurrentUser(respData?.user || {}));

        //Token has been invalidated, get a new one.
        unsetCsrfToken();
    }
}

export async function sendLogout(dispatch: Dispatch, lifeCycleCallback: (rs: RequestStatus) => any)
{
    const response = await makeApiRequest({
        endpoint: 'logout/',
        method: 'POST',
        dispatch,
        lifeCycleCallback,
    });

    if (response.success)
    {
        dispatch(loginActions.setCurrentUser(null));
        //Token has been invalidated, get a new one.
        unsetCsrfToken();
    }
}